"use strict";

var _defineProperty2 = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactJsonschemaForm = _interopRequireDefault(require("react-jsonschema-form"));
var _reactIntl = require("react-intl");
var _reactRouterDom = require("react-router-dom");
var _utils = require("../utils");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var FormCell = /*#__PURE__*/function (_react$default$PureCo) {
  function FormCell() {
    var _this;
    _classCallCheck(this, FormCell);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FormCell, [].concat(args));
    _defineProperty(_this, "state", {
      success: false,
      error: false
    });
    return _this;
  }
  _inherits(FormCell, _react$default$PureCo);
  return _createClass(FormCell, [{
    key: "areRequiredFieldsOk",
    value: function areRequiredFieldsOk(fields, formData) {
      var requiredFields = fields.filter(function (field) {
        return field.required;
      });
      var _iterator = _createForOfIteratorHelper(requiredFields),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var field = _step.value;
          if (!formData[field.name] || field.type === "email" && !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData[field.name])) {
            return false;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        cell = _this$props.cell,
        page = _this$props.page,
        intl = _this$props.intl,
        logEvent = _this$props.logEvent,
        defaultLanguage = _this$props.defaultLanguage;
      var _this$state = this.state,
        formData = _this$state.formData,
        success = _this$state.success,
        error = _this$state.error;
      var fields = cell.fields.filter(function (f) {
        return f.visible;
      });
      var maleLabel = intl.formatMessage({
        id: 'email_form.gender.male'
      });
      var femaleLabel = intl.formatMessage({
        id: 'email_form.gender.female'
      });
      var otherGenderLabel = intl.formatMessage({
        id: 'email_form.gender.other'
      });
      var schema = {
        type: "object",
        required: fields.filter(function (field) {
          return field.required;
        }).map(function (field) {
          return field.name;
        }),
        properties: fields.reduce(function (acc, field) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty2({}, field.name, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
            type: FormCell.schemaFieldType(field.type),
            title: (0, _utils.i18nData)(field, "label", intl, defaultLanguage)
          }, field.type === "integer" ? {
            minimum: 1
          } : {}), field.type === "select" ? {
            enum: field.options.map(function (option) {
              return option.name;
            }),
            enumNames: field.options.map(function (option) {
              return (0, _utils.i18nData)(option, 'label', intl, defaultLanguage);
            })
          } : {}), field.type === "multiple_choices" ? {
            type: "array",
            items: {
              type: "string",
              enum: field.options.map(function (option) {
                return option.name;
              }),
              enumNames: field.options.map(function (option) {
                return (0, _utils.i18nData)(option, 'label', intl, defaultLanguage);
              })
            },
            uniqueItems: true
          } : {}), field.type === "gender" ? {
            anyOf: [{
              const: "male",
              title: maleLabel
            }, {
              const: "female",
              title: femaleLabel
            }, {
              const: "other",
              title: otherGenderLabel
            }]
          } : {})));
        }, {})
      };
      var uiSchema = fields.reduce(function (acc, field) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty2({}, field.name, _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
          "ui:options": _objectSpread({
            "label": field.type === "gender"
          }, field.type === "email" ? {
            inputType: "email"
          } : {}),
          "ui:placeholder": (0, _utils.i18nData)(field, "label", intl, defaultLanguage),
          "ui:label": field.type === "multiple_choices" || field.type === "gender" ? (0, _utils.i18nData)(field, 'label', intl, defaultLanguage) : '',
          classNames: "tsku-form-".concat(field.type).concat(field.half_width ? ' tsku-form-half_width' : '')
        }, field.type === "integer" ? {
          "ui:widget": "updown"
        } : {}), field.type === "date" ? {
          'ui:widget': 'date'
        } : {}), field.type === "gender" ? {
          "ui:widget": "radio"
        } : {}), field.type === "multiple_choices" ? {
          "ui:widget": "checkboxes"
        } : {}), field.type === "select" ? {
          "ui:widget": "select"
        } : {})));
      }, {
        "ui:order": fields.map(function (field) {
          return field.name;
        })
      });
      console.log(formData);
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("style", {
        dangerouslySetInnerHTML: {
          __html: "\n          ".concat(cell.width > 18 ? "\n          .form_".concat(cell.id, " .field-string.tsku-form-half_width {\n            width: 100%;\n            display: inline-block;\n          }\n\n          .form_").concat(cell.id, " .field-array .checkboxes .checkbox {\n              display: inline-flex;\n              align-items: center;\n              margin-right: 1.5em;\n              margin-bottom: 0.5em;\n            }\n\n          .form_").concat(cell.id, " .tsku-form-gender div.field-radio-group {\n            display: inline-block;\n          }\n\n          .form_").concat(cell.id, " > div {\n            margin-right: 1em;\n          }\n          ") : "\n          .form_".concat(cell.id, " .field-string.tsku-form-half_width {\n            width: -webkit-fill-available;\n          }\n          "), "\n\n          .form_").concat(cell.id, " * {\n            font-family: \"").concat(cell.font, "\";\n          }\n\n          /* Hide react-jsonschema-form's required marker (*) */\n          .form_").concat(cell.id, " label .required {\n            display: none;\n          }\n\n          .form_").concat(cell.id, " label {\n            color: ").concat(cell.border_color, " !important;\n            margin-top: 2em !important;\n          }\n\n          .form_").concat(cell.id, " input[type=text],\n          .form_").concat(cell.id, " input[type=number],\n          .form_").concat(cell.id, " input[type=email] {\n            background-color: ").concat(cell.input_background_color, ";\n            color: ").concat(cell.input_text_color, ";\n            padding: 0.3em;\n            border: 2px solid ").concat(cell.border_color, ";\n            border-radius: 0.5em;\n            width: -webkit-fill-available;\n          }\n\n          .form_").concat(cell.id, " input[type=text],\n          .form_").concat(cell.id, " input[type=number],\n          .form_").concat(cell.id, " input[type=email] {\n            background-color: ").concat(cell.input_background_color, ";\n            color: ").concat(cell.input_text_color, ";\n            padding: 0.3em;\n            border: 2px solid ").concat(cell.border_color, ";\n            border-radius: 0.5em;\n            width: -webkit-fill-available;\n          }\n            .form_").concat(cell.id, " .checkbox label span{\n                font-size: 1.1em; !important\n              }\n\n          .form_").concat(cell.id, " input[type=radio] {\n            width: 0.7em !important;\n            height: 0.7em !important;\n            margin: 0.68em !important;            \n          }\n\n          .form_").concat(cell.id, " input[type=checkbox] {\n            width: 0.8em !important;\n            height: 0.8em !important;\n            margin-top: 0.28em !important;\n          }\n\n          .form_").concat(cell.id, " select{\n            color: ").concat(cell.input_text_color, ";\n            border: 2px solid ").concat(cell.border_color, ";\n            background-color: ").concat(cell.input_background_color, ";\n            border-radius: 0.5em;\n            padding: 0.3em;\n            width: 100%;\n            font-size: 1em;\n          }\n\n          .form_").concat(cell.id, " .btn-info {\n            color: ").concat(cell.submit_text_color, ";\n            border: 2px solid ").concat(cell.border_color, ";\n            background-color: ").concat(cell.submit_background_color, ";\n            font-size: 1em;\n          }\n\n          /* Style lorsque le bouton radio est coch\xE9 */\n          input[type=radio]:checked {\n            background-color: white !important; /* Changer la couleur de fond */\n            color: ").concat(cell.submit_text_color, " !important; /* Changer la couleur de fond */\n          }\n\n          .form_").concat(cell.id, " .tsku-confirmation-msg {\n            color: ").concat(cell.confirmation_text_color, ";\n            text-align: start;\n            margin-left: 2em;\n          }\n\n          .form_").concat(cell.id, " .tsku-error-msg {\n            color: ").concat(cell.error_text_color, ";\n            text-align: start;\n            margin-left: 2em;\n          }\n\n          .form_").concat(cell.id, " .control-label{\n            margin-top: 1.6em !important;\n            margin-bottom: 0.6em !important;\n            font-size: 1.4em !important;\n          }\n\n          .form_").concat(cell.id, " input{\n            margin-bottom: 0.4em !important;\n          }\n\n          label .control-label{\n            margin-top: 1.6em !important;\n            margin-bottom: 0.6em !important;\n          }\n\n          .form_").concat(cell.id, " label{\n            margin-bottom: 0.1em !important;\n            margin-top: 0.2em !important;\n          }\n        ")
        }
      }), /*#__PURE__*/_react.default.createElement(_reactJsonschemaForm.default, {
        formData: formData,
        autocomplete: "off",
        noHtml5Validate: true,
        showErrorList: false,
        noValidate: true,
        className: "form_".concat(cell.id, " tsku-form"),
        schema: schema,
        uiSchema: _objectSpread(_objectSpread({}, uiSchema), {}, {
          "ui:rootFieldId": "form_".concat(cell.id)
        }),
        onSubmit: function onSubmit(_ref, e) {
          var formData = _ref.formData;
          console.log(formData);
          if (!_this2.areRequiredFieldsOk(fields, formData)) {
            _this2.setState({
              formData: formData,
              success: false,
              error: true
            });
          } else {
            var eventType = cell.cell_type === "email_form" || cell.send_email ? "email" : "form";
            var data = _objectSpread({
              cellId: cell.id,
              pageId: page.id,
              languageCode: intl.locale
            }, formData);
            logEvent(eventType, data);
            _this2.setState({
              formData: formData,
              success: true,
              error: false
            });
            if (cell.redirect_page_id) {
              _this2.props.history.push("/page/".concat(cell.redirect_page_id));
            }
          }
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'tsku-form-bottom'
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: 'btn btn-info',
        type: "submit"
      }, (0, _utils.i18nData)(cell, "submit_button_text", intl, defaultLanguage)), !!success && /*#__PURE__*/_react.default.createElement("span", {
        className: 'tsku-confirmation-msg'
      }, (0, _utils.i18nData)(cell, "confirmation_text", intl, defaultLanguage)), !!error && /*#__PURE__*/_react.default.createElement("span", {
        className: 'tsku-error-msg'
      }, (0, _utils.i18nData)(cell, "error_text", intl, defaultLanguage)))));
    }
  }], [{
    key: "schemaFieldType",
    value: function schemaFieldType(type) {
      switch (type) {
        case "multiple_choices":
          return "array";
        case "gender":
        case "short_text":
        case "long_text":
        case "email":
        case "select":
        case "date":
          return "string";
        case "integer":
          return "integer";
        case "checkbox":
          return "boolean";
        default:
          throw new Error("Unknown field type: ".concat(type));
      }
    }
  }]);
}(_react.default.PureComponent);
_defineProperty(FormCell, "whyDidYouRender", true);
var _default = exports.default = (0, _reactRouterDom.withRouter)((0, _reactIntl.injectIntl)(FormCell));